import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Select from '../../../_common/Form/Selects/Select/Select';
import { getTeamRequest } from '../../../../store/actions/team';
import accountHelpers from '../../../../utils/accountHelpers';

const limit = 20;
function AssigneeSelect({ onchange, assigneeId, error }) {
  const dispatch = useDispatch();
  const [assignee, setAssignee] = useState({});

  useEffect(() => {
    (async () => {
      const { payload: { data: { data } } } = await dispatch(getTeamRequest({
        page: 1,
        limit,
        searcherId: accountHelpers.getUser().id,
        userRole: 'Pharmacy',
      }));
      setAssignee(data);
    })();
  }, []);

  const nextOptionListRequest = async (page) => {
    const { payload: { data: { data } } } = await dispatch(getTeamRequest({
      page, limit, searcherId: accountHelpers.getUser().id, userRole: 'Pharmacy',
    }));

    setAssignee((prev) => ({ response: [...prev.response, ...data.response], _meta: data._meta }));
  };
  return (
    <Select
      nextOptionListRequest={nextOptionListRequest}
      totalPage={assignee?._meta?.pageCount}
      currentPage={assignee?._meta?.currentPage}
      limit={limit}
      optionPathname="name"
      label="Assignee"
      onChange={(item) => onchange(item)}
      currentOption={assignee?.response?.find((a) => a.id === assigneeId)?.name}
      options={assignee.response}
      zIndex={30}
      optionValue
      error={error}
    />
  );
}

AssigneeSelect.protoTypes = {
  onchange: PropTypes.func.isRequired,
  assigneeId: PropTypes.number.isRequired,
  error: PropTypes.string,
};

AssigneeSelect.defautlProps = {
  error: '',
};

export default AssigneeSelect;
